// @ts-nocheck
const detectEnvironment = () => {
	if (typeof window !== "undefined") {
		const hostname = window.location.hostname;

		if (hostname === "debugaccess.onlyall.fr") {
			return "preprod";
		}
		if (hostname === "access.onlyall.fr") {
			return "prod";
		}
		if (hostname === "localhost" || hostname === "127.0.0.1") {
			return "local";
		}
	}

	return "preprod";
};

const env = detectEnvironment();

// Prefer VITE_API_URL if set (CI/CD injects it), fallback to hostname detection
const SERV_URL = import.meta.env.VITE_API_URL
	? import.meta.env.VITE_API_URL
	: env === "prod"
		? "https://apiv1.onlyall.fr/"
		: env === "local"
			? "http://localhost:3001/"
			: "https://onlyallapiv1-preprodapi.azurewebsites.net/";

// API_URL is computed first so the FILES_URL fallback can derive from it.
const API_URL_RAW = SERV_URL + (SERV_URL.endsWith("/") ? "" : "/");

const RAW_FILES_URL = import.meta.env.VITE_FILES_URL
	? import.meta.env.VITE_FILES_URL
	: env === "local"
		? "http://localhost:9000/onlyall-files/"
		: env === "prod"
			? "https://files.onlyall.fr/"
			// Non-prod default: route through the API's /storage/* public
			// endpoint instead of expecting a separate proxy rule for
			// /files/. Avoids the qualif failure mode where
			// `https://onlyall.docaret.com/files/...` had no upstream and
			// every file 504'd. The API has its own auth-bypass + Azure
			// fallback baked in.
			: API_URL_RAW + "storage/";

// Defensive trailing-slash: every consumer concatenates `FILES_URL + path`,
// so FILES_URL MUST end with `/`. A CI/CD env that ships VITE_FILES_URL
// without it (qualif had `https://onlyall.docaret.com/files` → produced
// `filesdocuments/foo.pdf` → 504) must not silently corrupt every file URL.
const FILES_URL = RAW_FILES_URL.endsWith("/") ? RAW_FILES_URL : RAW_FILES_URL + "/";

export const API_URL = API_URL_RAW;
export const PICTOS_URL = FILES_URL + "Pictos/";
export const PING_URL = FILES_URL + "ping.png";
export { SERV_URL, FILES_URL };
